import { defineStore } from 'pinia'

export const useGuestStore = defineStore('guestStore', () => {
  const tokens = ref({})

  /**
   * @param {string} eventId
   * @returns {string}
   */
  function getGuestEventToken(eventId) {
    return tokens.value[eventId]
  }

  /**
   * @param {string} eventId
   * @param {string} token
   * @returns {void}
   */
  function setToken(eventId, token) {
    tokens.value[eventId] = token
  }

  return {
    tokens,
    getGuestEventToken,
    setToken,
  }
})
